import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform(obj: unknown[], orderField: string, direction?: string): unknown[] {
    const orderType = direction ?? 'ASC';

    obj.sort(function (a: unknown, b: unknown): number {
      if (orderType === 'ASC') {
        if (a[orderField] < b[orderField]) return -1;
        if (a[orderField] > b[orderField]) return 1;
        return 0;
      } else {
        if (a[orderField] < b[orderField]) return 1;
        if (a[orderField] > b[orderField]) return -1;
        return 0;
      }
    });

    return obj;
  }
}
